import React from 'react';
import Modal from 'utils/packages/Modal';
import PremiumFeatureMicroModalContent from './PremiumFeatureMicroModalContent';
const PremiumFeatureMicroModal = {
    /**
     * @param onPress
     * @param benefitId
     * @param version v3 implemented separately
     */
    show: (onPress, benefitId, version) => {
        Modal.show(<PremiumFeatureMicroModalContent onContinue={() => {
                Modal.hide(onPress);
            }} onCancel={Modal.hide} benefitId={benefitId} version={version}/>);
    },
    hide: () => {
        Modal.hide();
    },
};
export default PremiumFeatureMicroModal;
